import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AppRoute } from 'src/app/constants/app.route';
import { EventType } from 'src/app/constants/events-type';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { HttpHandlerCallbacks } from 'src/app/core/component/interfaces/http-handlers-callbacks';
import { EventManagerService } from 'src/app/core/services/event-manager/event-manager.service';
import { EventContent } from 'src/app/core/services/event-manager/models/event-content';
import { RosterAdapterService } from 'src/app/core/services/http/roster/adapters/roster-adapter.service';
import { RosterUploadFileType } from 'src/app/core/services/http/roster/enums/roster-upload-file-types';
import { RosterService } from 'src/app/core/services/http/roster/roster.service';
import { clearFormControlsValues, disableFormGroup } from 'src/app/core/utils/utils';
import { AutoCompleteItem } from 'src/app/shared/auto-complete/interfaces/autocomplete-item';
import { FormGroupService } from 'src/app/shared/form-error/form-group.service';
import { getFormGroup } from '../form-group/form.group';
import { DrawerRef } from 'src/app/core/services/drawer/drawer-ref';
import { Alert } from 'src/app/shared/alert/types/alert';

@Component({
  selector: 'app-roster-add',
  templateUrl: './roster-add.component.html'
})
export class RosterAddComponent extends DestroyNotifierComponent implements HttpHandlerCallbacks<string> {
  form = getFormGroup();
  appRoute = AppRoute;
  uploadFileTypes = RosterUploadFileType;
  items: AutoCompleteItem[] = [];
  isOpenedInDrawer = false;

  clearFormControlsValues = clearFormControlsValues;
  disableFormGroup = disableFormGroup;

  constructor(
    private formGroupService: FormGroupService,
    private rosterService: RosterService,
    private router: Router,
    private rosterAdapterService: RosterAdapterService,
    private eventManager: EventManagerService,
    @Optional() public drawerRef: DrawerRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.isOpenedInDrawer = this.drawerRef?.drawerData.isOpenInDrawer || false;
  }

  onSubmit(): void {
    this.formGroupService.validateFormGroup(this.form);

    if (this.form.invalid) {
      return;
    }

    const requestBody = this.rosterAdapterService.formGroupToRosterRequest(this.form);

    if (requestBody) {
      this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, true));

      this.rosterService
        .post(requestBody)
        .pipe(takeUntil(this.destroyNotify))
        .subscribe((groupData:any) => {
          if(this.isOpenedInDrawer){
            this.drawerRef.close(groupData);
            const alert: Alert = {
              type: 'success',
              dismissOnTimeout: 0,
              translateKey: "GROUP_ADDED_SUCCESS",
            };
            
            this.eventManager.broadcast(new EventContent(EventType.AlertMessage, alert));
            this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, false));
          }else{
            this.onSuccess()
          }
      });
    }
  }

  onBack(): void {
    if(this.isOpenedInDrawer){
      this.drawerRef.close();
    }else{
      this.router.navigateByUrl(AppRoute.Roster);
    }
  }

  onSuccess(): void {
    this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, false));
    this.router.navigateByUrl(AppRoute.Roster);
  }

  onClose(): void {
    this.drawerRef.close();
  }
}
